<template>
	<div class="download-specs-block">
		<h5 class="download-specs-header">{{ $resourceString["virtualtray.download.specs.modal.header"] }}</h5>
		<button type="button" class="wf-modal-button-close btn button-full" @click="hideModal('download-specs')">
      <span aria-label="Close modal" class="png-icon png-icon-icons-symbols--k-txtclose">

      </span></button>
		<h6 class="download-specs-subheader">
			{{ $resourceString["virtualtray.download.specs.modal.subheader"] }}
		</h6>
		<p class="download-specs-no-items-fm" v-if="Object.keys(trayData).length === 0">{{ $resourceString["virtualtray.no.items.1"] }}</p>
		<p class="download-specs-no-items-sm" v-if="Object.keys(trayData).length === 0">{{ $resourceString["virtualtray.no.items.2"] }}</p>
		<ul class="download-specs-list" v-if="getPdmsLinks.length > 0">
			<li class="download-specs-list-element d-flex" v-for="item in getPdmsLinks" :key="item.id">
				<img class="download-specs-image" :src="item.backgroundTileImage"/>
				<a class="download-specs-link spec-pdf-download" :href="item.pdmsLink" target="_blank">
					{{ (item.sellingStyleNumber ? item.sellingStyleNumber :item.styleNumber)  + " " + (item.sellingStyleName ? item.sellingStyleName :item.styleName) }}
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
			trayData: "virtualTray/trayData",
			getPdmsLinks: "virtualTray/getPdmsLinks",
    }),
  },
  methods: {
	hideModal(name) {
      this.$modal.hide(name + "-modal");
    },
  },
}
</script>

<style>
</style>